import { render, staticRenderFns } from "./GoldenDustMenu.vue?vue&type=template&id=b98decda&scoped=true"
import script from "./GoldenDustMenu.vue?vue&type=script&lang=js"
export * from "./GoldenDustMenu.vue?vue&type=script&lang=js"
import style0 from "./GoldenDustMenu.vue?vue&type=style&index=0&id=b98decda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98decda",
  null
  
)

export default component.exports